import React from "react";
import { useHomeData } from "../../shared/hooks";

const Data = ({ data = null }) => {
  const defaultData = useHomeData();

  // Use passed data if available, otherwise use hook data
  const displayData = data || defaultData.data;

  return (
    <div className="home__data">
      <h1 className="home__title">{displayData?.title || ""}</h1>
      <h2 className="home__subtitle">{displayData?.subtitle || ""}</h2>
      <p className="home__description">{displayData?.description || ""}</p>

      <a
        href="#contact"
        className="button button--flex"
        style={{
          padding: "0.90rem 2rem",
        }}
      >
        Say Hello
        <i
          style={{ fontSize: "1.5rem", marginLeft: "0.5rem" }}
          className="uil uil-message"
        ></i>
      </a>
    </div>
  );
};

export default Data;
